import HomeStepper from './home-stepper.component';

export default HomeStepper;
